// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"593":"13c42d5c","652":"21980183"}[chunkId] + ".js";
};